import { Component } from '@theme/component';
import { ProductSelectEvent, StandardEvents } from '@shopify/events';

class TeylensPurchaseControls extends Component {
  #abortController;
  #selectionGeneration = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.closest('.shopify-section, dialog, product-card')?.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
      { signal }
    );
    this.addEventListener('submit', this.#guardQuoteSubmit, { capture: true, signal });
    this.addEventListener('click', this.#guardPendingInquiry, { capture: true, signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    this.#selectionGeneration++;
  }

  /** @param {SubmitEvent} event */
  #guardQuoteSubmit = (event) => {
    if (this.dataset.quoteRequired !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  /** @param {MouseEvent} event */
  #guardPendingInquiry = (event) => {
    if (this.getAttribute('aria-busy') !== 'true') return;
    if (!(event.target instanceof Element) || !event.target.closest('[data-product-inquiry] a')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  /** @param {ProductSelectEvent} event */
  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const generation = ++this.#selectionGeneration;
    this.setAttribute('aria-busy', 'true');
    try {
      const { detail } = await event.promise;
      if (generation !== this.#selectionGeneration || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.getElementById(this.id);
      if (!(next instanceof HTMLElement)) return;
      const quoteRequired = next.dataset.quoteRequired === 'true';
      this.dataset.quoteRequired = String(quoteRequired);
      this.dataset.productId = next.dataset.productId ?? this.dataset.productId;
      const nativePurchase = this.querySelector('[data-native-purchase]');
      const inquiry = this.querySelector('[data-product-inquiry]');
      const nextInquiry = next.querySelector('[data-product-inquiry]');
      if (nativePurchase instanceof HTMLElement) nativePurchase.hidden = quoteRequired;
      if (inquiry instanceof HTMLElement && nextInquiry) {
        inquiry.replaceChildren(...Array.from(nextInquiry.childNodes).map((node) => node.cloneNode(true)));
        inquiry.hidden = !quoteRequired;
      }
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[product-inquiry] Could not update the selected quote.', error);
    } finally {
      if (generation === this.#selectionGeneration) this.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('teylens-purchase-controls')) {
  customElements.define('teylens-purchase-controls', TeylensPurchaseControls);
}
